module.exports = __webpack_public_path__ + "img/0029.fc2d739a.jpg";